import { render } from "./ElevesExam.vue?vue&type=template&id=3e3bfa5a&scoped=true"
import script from "./ElevesExam.vue?vue&type=script&lang=js"
export * from "./ElevesExam.vue?vue&type=script&lang=js"

import "./ElevesExam.vue?vue&type=style&index=0&id=3e3bfa5a&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e3bfa5a"]])

export default __exports__